__turbopack_context__.v({
  "container": "generate-image-module__OGhkwG__container",
  "content": "generate-image-module__OGhkwG__content",
  "form": "generate-image-module__OGhkwG__form",
  "formContainer": "generate-image-module__OGhkwG__formContainer",
  "input": "generate-image-module__OGhkwG__input",
  "select": "generate-image-module__OGhkwG__select",
  "title": "generate-image-module__OGhkwG__title",
});
